/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_7_QInputs */

const en_mk_faq_7_q = /** @type {(inputs: Mk_Faq_7_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I work with a team or clients?`)
};

const id_mk_faq_7_q = /** @type {(inputs: Mk_Faq_7_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisa dipakai bersama tim atau klien?`)
};

/**
* | output |
* | --- |
* | "Can I work with a team or clients?" |
*
* @param {Mk_Faq_7_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_7_q = /** @type {((inputs?: Mk_Faq_7_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_7_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_7_q(inputs)
	return en_mk_faq_7_q(inputs)
});